import React, { useEffect, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import PolicyLinks from "./PolicyLinks";
import "../styles/site.css";

const FooterPage = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 400);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {showScrollTop && (
        <button
          type="button"
          className="scroll-top-floating"
          aria-label="Go to top"
          onClick={scrollToTop}
        >
          <i className="bi bi-arrow-up"></i>
        </button>
      )}
      <footer className="site-footer">
        <div className="container">
          <div className="site-footer-grid">
            <div>
              <div className="site-footer-brand">
                <img src="/img/icon.png" alt="" width="40" height="40" />
                Indian Odyssey
              </div>
              <p>Handpicked experiences across India. Flexible plans, transparent pricing, and friendly support.</p>
            </div>
            <div>
              <h3>Contact</h3>
              <ul>
                <li><i className="bi bi-telephone" aria-hidden="true" /><a href="tel:+919121943442">+91 91219 43442</a></li>
                <li><i className="bi bi-envelope" aria-hidden="true" /><a href="mailto:indianodysseyofficial@gmail.com">indianodysseyofficial@gmail.com</a></li>
                <li><i className="bi bi-geo-alt" aria-hidden="true" /><span>Sarpavaram, Kakinada, Andhra Pradesh</span></li>
              </ul>
            </div>
            <div>
              <h3>Travel policy</h3>
              <PolicyLinks />
            </div>
          </div>
          <div className="site-footer-bottom">
            Copyright &copy; {new Date().getFullYear()} Indian Odyssey
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterPage;
